import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_ProviderDischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_ProviderDischargeSummary' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><center><h4>Provider Discharge Summary</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Effective Date of Discharge</span> </td>
                        <td className='w-375'> <span className='eleHeader'>ID Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDischargeDate' name='txtDischargeDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtProviderIdNumber' name='txtProviderIdNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Reason For Discharge: </span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEvaluationOnly' name='cbEvaluationOnly' className='add-only' value='Evaluation Only' /> Evaluation Only </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServiceArea' name='cbServiceArea' className='add-only' value='Moved from service area' /> Moved from service area </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentCompleted' name='cbTreatmentCompleted' className='add-only' value='Treatment Completed' /> Treatment Completed
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDeceased' name='cbDeceased' className='add-only' value='Deceased' /> Deceased </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbProviderTerminated' name='cbProviderTerminated' className='add-only' value='Provider Terminated Treatment' /> Provider Terminated Treatment </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNoContact' name='cbNoContact' className='add-only' value='No contact in 12 months' /> No contact in 12 months
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividualReferred' name='cbIndividualReferred' className='add-only' value='Individual Referred Elsewhere' /> Individual Referred Elsewhere </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividualRequested' name='cbIndividualRequested' className='add-only' value='Individual requested discharge' /> Individual requested discharge
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonOther' name='cbReasonOther' className='add-only' value='Other' /> Other: <br />
                            <input type='text' id='txtReasonOther' name='txtReasonOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Referred To: </span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBehavioralHealth' name='cbBehavioralHealth' className='add-only' value='DMH Behavioral Health' /> DMH Behavioral Health Program </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyFriend' name='cbFamilyFriend' className='add-only' value='Family/Friend' /> Family/Friend</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrivatePrtf' name='cbPrivatePrtf' className='add-only' value='Private PRTF' /> Private PRTF
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOtherMsCmhc' name='cbOtherMsCmhc' className='add-only' value='Other MS CMHC' /> Other MS CMHC </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolEducation' name='cbSchoolEducation' className='add-only' value='School/Education' /> School/Education </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrivateIcf' name='cbPrivateIcf' className='add-only' value='Private ICF/IID' /> Private ICF/IID
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDmhIddProgram' name='cbDmhIddProgram' className='add-only' value='DMH IDD Program' /> DMH IDD Program </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEmployer' name='cbEmployer' className='add-only' value='Employer/EAP' /> Employer/EAP
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricHospital' name='cbPsychiatricHospital' className='add-only' value='Private Psychiatric Hospital' /> Private Psychiatric Hospital </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPolice' name='cbPolice' className='add-only' value='Police/Sheriff' /> Police/Sheriff
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMhProvider' name='cbMhProvider' className='add-only' value='Other MH Provider' /> Other MH Provider </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCorrections' name='cbCorrections' className='add-only' value='Courts/Corrections' /> Courts/Corrections
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIddProvider' name='cbIddProvider' className='add-only' value='Other IDD Provider' /> Other IDD Provider </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbProbation' name='cbProbation' className='add-only' value='Probation/ Parole' /> Probation/ Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOtherProvider' name='cbOtherProvider' className='add-only' value='Other A&D Provider' /> Other A&D Provider </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfHelpProgram' name='cbSelfHelpProgram' className='add-only' value='Self Help Program' /> Self Help Program
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHospital' name='cbHospital' className='add-only' value='Gen/Hospital/Other Health' /> Gen/Hospital/Other Health </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbJobPlacement' name='cbJobPlacement' className='add-only' value='Voc Rehab/Job Placement' /> Voc Rehab/Job Placement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelf' name='cbSelf' className='add-only' value='Self' /> Self </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLicensedPersonal' name='cbLicensedPersonal' className='add-only' value='Licensed Personal Care Home' /> Licensed Personal Care Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReferredOther' name='cbReferredOther' className='add-only' value='Other' /> Other: <br />
                            <input type='text' id='txtReferredOther' name='txtReferredOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Discharge Instructions Provided to </span> </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividual' name='cbIndividual' className='add-only' value='Individual' /> Individual </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLegalRepresentative' name='cbLegalRepresentative' className='add-only' value='Legal Representative' /> Legal Representative </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Discharge Instructions/Additional Information: </span>
                    <textarea id='txtAdditionalInformation' name='txtAdditionalInformation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Individual/Legal Representative </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







